import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Divider, Radio, Select, Space, Spin, Table} from "antd";
import {Link} from "react-router-dom";
import {divide1toPct, handleRank, setKey, str2Timestamp} from "../../util/util";
import Icon from "../Icon";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";

export default () => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [myRank, setMyRank] = useState(-1)



    const seasonTime = {
        "0": {beginTime: str2Timestamp('2025/7/25 03:57:28'), endTime: null},

        "1": {beginTime: str2Timestamp('2023/1/3 22:00:00'), endTime: str2Timestamp('2023/1/7 9:25:00')},

        "2": {beginTime: str2Timestamp('2023/1/7 9:25:00'), endTime: str2Timestamp('2023/3/1 20:15:00')},

        "3": {beginTime: str2Timestamp('2023/3/1 20:15:00'), endTime: str2Timestamp('2023/6/12 11:56:07')},

        "4": {beginTime: str2Timestamp('2023/6/12 11:56:07'), endTime: str2Timestamp('2023/8/31 20:30:00')},

        "5": {beginTime: str2Timestamp('2023/8/31 20:30:00'), endTime: str2Timestamp('2023/11/16 20:00:00')},

        "6": {beginTime: str2Timestamp('2023/11/16 20:00:00'), endTime: str2Timestamp('2024/3/20 02:55:23')},

        "7": {beginTime: str2Timestamp('2024/3/20 02:55:23'), endTime: str2Timestamp('2024/10/6 20:04:46')},

        "8": {beginTime: str2Timestamp('2024/10/6 20:04:46'), endTime: str2Timestamp('2025/7/25 03:57:28')},
    }

    const season = [
        {
            value: '0',
            label: `${t('season')} 8`,
        },
        // {
        //     value: '1',
        //     label: `${t('season')} 1 ${t('preseason')}`,
        // },
        {
            value: '2',
            label: `${t('season')} 1`,
        },
        {
            value: '3',
            label: `${t('season')} 2`,
        },
        {
            value: '4',
            label: `${t('season')} 3`,
        },
        {
            value: '5',
            label: `${t('season')} 4`,
        },
        {
            value: '6',
            label: `${t('season')} 5`,
        },
        {
            value: '7',
            label: `${t('season')} 6`,
        },
        {
            value: '8',
            label: `${t('season')} 7`,
        },
    ]

    const columns = [
        {
            key: 'rank',
            dataIndex: 'rank',
            title: t('rank'),
            render: (rank) => <b>{rank}</b>,
            align: 'center',
        },
        {
            key: 'player',
            dataIndex: 'player',
            title: t('players'),
            render: (_, p) =>
                <Link to={`/player/${p.handle}`} >
                <Space>
                {
                    p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={32} icon={<UserOutlined />} />
                        : <Avatar shape="square" size={32} icon={<UserOutlined />} />
                }
                <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
            </Space>
                </Link>,
            align: 'left',
            width: 300
        },
        {
            key: 'mmr',
            dataIndex: 'mmr',
            title: t('points'),
            render: (mmr, p) => <div style={{ position: "relative" }}>
                <b>{mmr}</b>
                <b style={{ color: p.color, fontSize: "20px", position: "absolute", top: '-6px', right: "6px" }}>{p.flag}</b>
            </div>,
            align: 'center',
            width: 120
        },
        {
            key: 'wins',
            dataIndex: 'wins',
            title: t('wins'),
            align: 'center',
        },
        {
            key: 'losses',
            dataIndex: 'losses',
            title: t('losses'),
            align: 'center',
        },
        {
            key: 'winPercentage',
            dataIndex: 'winPercentage',
            title: t('heroListTitle.winPercentage'),
            render: (_, p) => <span>{divide1toPct(p.wins,p.wins + p.losses)}%</span>,
            align: 'center',
        },
        {
            key: 'commonHeroes',
            dataIndex: 'commonHeroes',
            title: t('commonHeroes'),
            align: 'center',
            render: (_, p) => p.commonHeroes.map((p) => <Icon type={'hero'} key={p} name={p} size={28} />),
        },
    ]

    const update = (seasonNum) => {
        setLoading(true)
        axios.get(`player/rank`, {
            params: {
                season: seasonNum,
                beginTime: seasonTime[seasonNum].beginTime,
                endTime: seasonTime[seasonNum].endTime,
            }
        }).then(data => {
            setKey(data.list, 'handle')
            setMyRank(data.myRank)
            for (const player of data.list) {
                let flag0 = '↑'
                let color = '#52c41a'
                let streak = player.winStreak
                if (player.loseStreak > 0) {
                    flag0 = '↓'
                    color = '#f5222d'
                    streak = player.loseStreak
                }
                let flag = flag0
                if (streak >= 3) {
                    flag += flag0
                }
                if (streak >= 5) {
                    flag += flag0
                }
                player.flag = flag
                player.color = color
                if (player.loseStreak === 0 && player.winStreak === 0) {
                    player.flag = ""
                }
            }
            handleRank(data.list)
            setData(data.list)
            setLoading(false)
        })
    }

    useEffect(() => {
      update('0')
    }, [])

    return <Space direction={'vertical'} size={30}>
        <Space>
            {new Array(63 - 52 + 1).fill(0).map((_, i) => <Icon key={i + 52} name={i + 52} type={'ico'} size={56} /> )}
        </Space>

        <Space size={40}>
            <Select
                defaultValue={'0'}
                style={{}}
                onChange={(e) => {

                        update(e.toString())
                    }
                }
                options={season}
            />
            <b style={{ fontSize: "24px" }}>{t('myRank')}
                {
                    loading ? <Spin /> : (myRank !== -1 ? myRank : t('noRank'))
                }

            </b>
        </Space>

        <Table size={'small'} style={{ }} columns={columns} pagination={false} dataSource={data} loading={loading}/>
    </Space>
}
